import { createRouter, createWebHistory } from 'vue-router'
import PersonageRoutes from './personage';
import TopicRoutes from './topic'
import ResourceRoutes from './resource'
import Peoples from './peoples';

const Main = () => import('@/views/main')

const Search = () => import('@/views/search')
const SearchResult = () => import('@/views/search/result')

const PointStore = () => import('@/views/my/point/store')
const PointStoreDetail = () => import('@/views/my/point/store/detail')
const PointSucceed = () => import('@/views/my/point/store/succeed')
const PointOrder = () => import('@/views/my/point/store/succeed/detail')
const PointHistory = () => import('@/views/my/point/history')

const defaultTitle = '数字资源推广特色数据库'

const routes = [
    {
        path: '',
        redirect: '/main'
    },
    {
        path: '/',
        redirect: '/main'
        // redirect: '/personage/main'
    },
    {
        component:()=> import("@/views/mainNav"),
        children:[
            {
                path: '/main',
                name: 'Main',
                component: Main,
                meta: {
                    title: defaultTitle
                }
            },
            {
                path: '/column',
                name: 'column',
                component: () => import('@/views/column'),
                meta: {
                    title: '栏目'
                }
            },
            {
                path: '/activity',
                name: 'Activity',
                component: () => import('@/views/activity'),
                meta: {
                    title: '活动'
                }
            },
            {
                path: '/my',
                name: 'my',
                component: () => import('@/views/my'),
                meta: {
                    title: '我的'
                }
            },
            {
                path: '/login',
                name:'Login',
                component:() => import("@/views/my/login"),
                meta: {
                    title: '登录注册'
                }
            },
        ]
    },

    ...Peoples,
    /** 历史名人专题数据库路由 */
    ...PersonageRoutes,
    /** 数字图书等 二级页面路由 */
    ...TopicRoutes,
    /** 资源页 路由 */
    ...ResourceRoutes,

    {
        path: '/activity/detail/:id',
        name: 'ActivityDetail',
        props: true,
        component: () => import('@/views/activity/detail'),
        meta: {
            title: '活动详情'
        }
    },

    {
        path: '/search',
        name: 'Search',
        component: Search,
        meta: {
            title: '搜索'
        }
    },
    {
        path: '/search/result',
        name: 'SearchResult',
        component: SearchResult,
        props: true,
        meta: {
            title: '搜索结果'
        }
    },

    {
        path: '/my/point/store',
        name: 'PointStore',
        component: PointStore,
        meta: {
            title: '积分兑换'
        }
    },
    {
        path: '/my/point/store/detail',
        name: 'PointStoreDetail',
        props: true,
        component: PointStoreDetail,
        meta: {
            title: '积分兑换详情'
        }
    },
    {
        path: '/my/point/store/succeed',
        name: 'PointStoreSucceed',
        props: true,
        component: PointSucceed,
        meta: {
            title: '积分兑换成功'
        }
    },
    {
        path: '/my/point/store/succeed/detail',
        name: 'PointOrder',
        props: true,
        component: PointOrder,
        meta: {
            title: '积分兑换详情'
        }
    },
    {
        path: '/my/point/history',
        name: 'PointHistory',
        props: true,
        component: PointHistory,
        meta: {
            title: '我的积分'
        }
    },

    // 我的收藏
    {
        path: '/my/collect',
        name: 'MyCollect',
        props: true,
        component: () => import("@/views/my/collect"),
        meta: {
            title: '我的收藏'
        }
    },
    // 个人信息
    {
        path: '/my/info',
        name: 'MyInfo',
        props: true,
        component: () => import("@/views/my/info"),
        meta: {
            title: '个人信息'
        }
    },
    // 设置
    {
        path: '/my/setting',
        name: 'MySetting',
        props: true,
        component: () => import("@/views/my/setting"),
        meta: {
            title: '设置'
        }
    },
    // 我的兑换
    {
        path:"/my/precious",
        name: "myPrecious",
        props: true,
        component: () => import("@/views/my/point/precious"),
        meta: {
            title: '我的兑换'
        }
    },

    {
        path: '/column/audio-book/:code',
        name: 'AudioBook',
        props: true,
        component: () => import('@/views/column/audioBook'),
        meta: {
            title: '数字听书'
        }
    },
    {
        path: '/column/stories/:code',
        name: 'ColumnStories',
        props: true,
        component: () => import('@/views/column/stories'),
        meta: {
            title: '故事会'
        }
    },

    {
        path: '/column/paints/:code',
        name: 'ColumnPaints',
        props: true,
        component: () => import('@/views/column/paints'),
        meta: {
            title: '简笔画、课堂教学'
        }
    },

]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
